import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getChannelList } from "@/api/aymentsdk/getchancllist";
import channleDialog from "./components/addChannle";
import { deleChannel } from "@/api/aymentsdk/getchancllist";
import { allChannel } from "@/api/aymentsdk/getchancllist"; // import { login } from '@/api/user';

export default {
  name: "loginChannelList",
  components: {
    channleDialog: channleDialog
  },
  data: function data() {
    return {
      dialog: false,
      typeValue: "",
      searchgames: [],
      tableData: [],
      page: 1,
      total: 0,
      pagSize: 10,
      num: "",
      form: {},
      id: "",
      bindObj: {}
    };
  },
  created: function created() {
    this.getType();
    this.getAllChannel();
  },
  methods: {
    getType: function getType() {
      var _this = this;

      getChannelList().then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      });
    },
    getAllChannel: function getAllChannel() {
      var _this2 = this;

      allChannel().then(function (res) {
        _this2.advchannels = res.data;
      });
    },
    addType: function addType() {
      this.dialog = true;
      this.num = "1";
    },
    editType: function editType(item) {
      this.dialog = true;
      this.num = "2";
      this.bindObj = item;
    },
    deleType: function deleType(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该类型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleChannel({
                  id: id
                }).then(function (res) {
                  _this3.getType();
                });

                _this3.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    handleSource: function handleSource(id) {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.$refs.addPayType.init(id);
      });
    },
    changeShow: function changeShow(val) {
      this.dialog = val;
      this.getType();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getType();
    },
    changeData: function changeData(val) {
      this.bindObj = val;
    }
  }
};